import { render, staticRenderFns } from "./LoadingNext.vue?vue&type=template&id=2672ae19&scoped=true&"
var script = {}
import style0 from "./LoadingNext.vue?vue&type=style&index=0&id=2672ae19&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2672ae19",
  null
  
)

export default component.exports